import { Injectable } from "@angular/core";
import * as moment from "moment";
import { environment } from "../../../../environments/environment";
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: "root"
})
export class CoreService {
  //private rootPath = 'http://localhost:8010/api/manager';
  private rootPath = environment.rootPath;
  private appName = "manager";
  private userType = "manager";
  public fullScreenSubject = new BehaviorSubject<boolean>(false);

  constructor() { }




  public getRootPath() {
    return this.rootPath;
  }

  toggleScreen (){
    if (this.fullScreenSubject.value){
      this.fullScreenSubject.next (false);
    }else {
      this.fullScreenSubject.next (true);
    }
  }

  getSaveDateFormat() {
    return "DD-MMM-YYYY";
  }

  public toDate(s) {
    return moment(s, this.getSaveDateFormat()).toDate();
  }
  
  public fromDate(d) {
    return moment(d).format(this.getSaveDateFormat());
  }

  toDateStr(d) {
    return moment(d).format(this.getSaveDateFormat());
  }

  getSaveTimeFormat() {
    return "hh:mm A";
  }

  toTime(t) {
    return moment(t).format(this.getSaveTimeFormat());
  }

  public isNumeric(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public getAppName() {
    return this.appName;
  }

  public getUserType() {
    return this.userType;
  }

  public validateFloatKeyPress(el, evt) {
    var charCode = evt.which ? evt.which : evt.keyCode;
    var number = el.split(".");
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    //just one dot
    if (number.length > 1 && charCode == 46) {
      return false;
    }
    //get the current position
    var caratPos = el.lastIndexOf(document.getSelection());
    var dotPos = el.indexOf(".");
    if (caratPos > dotPos && dotPos > -1 && number[1].length > 1) {
      return false;
    }
    return true;
  }

  isChar(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;

    if (
      charCode > 32 &&
      ((charCode < 48 || charCode > 90) &&
        (charCode < 97 || charCode > 122) &&
        charCode != 39)
    ) {
      return false;
    }
    return true;
  }

  isNotSpecialCharAndNumber(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;

    if (
      charCode > 32 &&
      ((charCode < 65 || charCode > 90) &&
        (charCode < 97 || charCode > 122))
    ) {
      return false;
    }
    return true;
  }

  isNotSpace(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;

    if (
      charCode > 31 &&
      ((charCode < 33 || charCode > 126))
    ) {
      return false;
    }
    return true;
  }

  isNotDotsAndNegeativeValue(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;

    if (
      charCode > 31 &&
      ((charCode < 33 || charCode > 44)) &&

      ((charCode < 47 || charCode > 126))
    ) {
      return false;
    }
    return true;
  }

  isNotDotAndNegeativeValue(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;

    if (
      charCode > 32 &&
      ((charCode < 33 || charCode > 44)) &&

      ((charCode < 47 || charCode > 126))
    ) {
      return false;
    }
    return true;
  }

  isNumSpecialCharNotDots(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;

    if (
      charCode > 31 &&
      ((charCode < 33 || charCode > 45) &&
        (charCode < 47 || charCode > 64) &&
        (charCode < 91 || charCode > 96) &&
        (charCode < 123 || charCode > 126)

      )
    ) {
      return false;
    }
    return true;
  }

  public getDate(vdate) {
    if (vdate) {
      return moment(vdate).format("DD-MMM-YYYY");
    } else {
      return "";
    }
  }

  public compareFn(a, b) {


    if (a && b && a.code && b.code) {
      return a.code == b.code;
    }

    if (a && b && a._id && b._id) {
      return a._id == b._id;
    }

    return false;
  }

  isNotAlphabetNotSpecialCharNotSpace(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;

    if (
      charCode > 31 &&
      ((charCode < 48|| charCode > 57)  && (charCode < 97 || charCode > 122) )
    ) {
      return false;
    }
    return true;
  }

}
